package com.trevorwiebe.timesheet.loads.domain.usecases

import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.loads.domain.LoadsRepository
import com.trevorwiebe.timesheet.loads.domain.model.Load
import kotlinx.datetime.LocalDate


class MoveLoad(
    private val loadsRepository: LoadsRepository,
) {
    suspend fun invoke(
        load: Load,
        scheduledDate: LocalDate?,
        employeeId: String,
        carrierId: String = "",
    ): TSResult =
        loadsRepository.updateLoad(
            load.copy(
                scheduledDate = scheduledDate,
                employeeId = if (scheduledDate == null || carrierId.isNotEmpty()) "" else employeeId,
                carrierId = if (scheduledDate == null) "" else carrierId,
                dispatchConfirmed = false,
            ),
        )
}
